// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"d3358bda","386":"48591fd9","515":"a7718273","540":"ec622a60","843":"95c024f2","994":"be79d5fa"}[chunkId] + ".chunk.css";
};